import { useThreeContext } from "@/components/common/three-context/three-context";
import { useMemo } from "react";

/**
 * @returns the color of the annotation icons drawn on the scene, which they inherit from the canvas container.
 * Used to keep the annotation symbol in its original colors inside dark UI such as the capture previews.
 * Works inside and outside the canvas
 */
export function useAnnotationIconColor(): string | undefined {
  const canvas = useThreeContext().renderer?.domElement;
  // The HTML overlays of the scene (e.g. annotations) are rendered in the parent of the canvas
  return useMemo(
    () =>
      canvas
        ? getComputedStyle(canvas.parentElement ?? canvas).color
        : undefined,
    [canvas],
  );
}
